import { Link } from 'react-router-dom';

export function Logo() {
  return (
    <Link to="/" className="flex items-center gap-2 group">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="stroke-ll-cyan"
      >
        <rect x="1" y="4" width="14" height="3" rx="0.5" strokeWidth="1.5" strokeLinejoin="round" />
        <rect x="3" y="9" width="10" height="3" rx="0.5" strokeWidth="1.5" strokeLinejoin="round" />
      </svg>
      <span className="font-sans text-xl font-bold">
        <span className="text-ll-text">Layer</span>
        <span className="text-ll-cyan">Lint</span>
      </span>
    </Link>
  );
}
